module.exports = __webpack_public_path__ + "media/choosing_a_college/Copy_of_iStock_000010758286XSmall_max120w-defa7df6.jpg";